/**
 * Enumeration of the edge types.
 */
export const TrailblazerEdgeType = Object.freeze({
    DIRECT: "DIRECT",
    LOGICAL: "LOGICAL"
});

/**
 * Enumeration of node types.
 */
export const TrailblazerNodeType = Object.freeze({
    BASE: "BASE",
    COLLAPSED: "COLLAPSED"
});

export const TrailblazerRouteHopType = Object.freeze({
    DEVICE: "DEVICE",
    ERROR: "ERROR",
    SYSTEM: "SYSTEM"
});

export const linkType = "linkType";